import { motion } from "framer-motion";

const easing = [0.22, 1, 0.36, 1];

// Fade + rise on scroll into view.
export const Reveal = ({ children, delay = 0, y = 28, className = "", ...rest }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, ease: easing, delay }}
    className={className}
    {...rest}
  >
    {children}
  </motion.div>
);

// Staggered container for children reveals.
export const StaggerGroup = ({ children, className = "", stagger = 0.08 }) => (
  <motion.div
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ show: { transition: { staggerChildren: stagger } } }}
    className={className}
  >
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", y = 24 }) => (
  <motion.div
    variants={{
      hidden: { opacity: 0, y },
      show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: easing } },
    }}
    className={className}
  >
    {children}
  </motion.div>
);

// Masked line-by-line reveal for hero typography.
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, ease: easing, delay }}
    >
      {children}
    </motion.span>
  </span>
);
